import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { clearValue, setBooking, setExcess, setPhone2, setPhone3, setRefund, setStep } from "../../../Reducer/bookingSlice"
import Handler from "../../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../../Helpers/Utils";
import Modal from "../../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import CustomerEdit from './CustomerEdit'
import Trip from "./Trip";
import Payment from "./Payment";
import Other from "./Other";
import Pending from "./Pending";
import Price from "./Price";
import { useAuth } from "../../../Contexts/AuthenticateProvider";

const Delivery = () => {
    const { id } = useParams()
    const [bookingId, setBookingId] = useState("")
    const [loading, setLoading] = useState(false)
    const booking = useSelector(state => state.booking.booking)
    const step = useSelector(state => state.booking.step)
    const [preview, setPreview] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { userDetails } = useAuth()
    const [leadList, setLeadList] = useState([])
    const [prev, setPrev] = useState({ delivery: 0, pickup: 0, securityDeposit: 0 })
    const normalizePendingPhotos = (pendingPhoto) => {
        try {
            if (!Array.isArray(pendingPhoto)) return [];
            if (
                pendingPhoto.length === 1 &&
                typeof pendingPhoto[0] === "string" &&
                pendingPhoto[0].trim().startsWith("[")
            ) {
                try {
                    const parsed = JSON.parse(pendingPhoto[0]);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }
            return pendingPhoto;
        } catch (err) {
            return []
        }
    }
    const getLeadList = async () => {
        const response = await Handler({ method: "get", url: `/booking/lead-list`, })
        if (response?.success) {
            const lead = response?.data
            if (lead?.length) {
                const stageHistory = booking.stageHistory?.length ? booking.stageHistory?.find(element => element.stage === "Completed") : ""
                // let delivered = stageHistory?.staffId || ""
                // let pickupBy = delivered || userDetails?.id || userDetails?.adminId
                const filteredLead = lead?.filter(element => element?.leadId !== userDetails?.id && element?.leadId !== userDetails?.adminId)
                const ourName = lead?.find(element => element?.leadId === userDetails?.id || element?.leadId === userDetails?.adminId)
                // if (booking?.pickupBy !== pickupBy) {
                //     dispatch(setBooking({ pickupBy }));
                // }
                setLeadList([...(ourName ? [{ label: ourName?.name?.toUpperCase(), value: ourName?.leadId }] : []), ...(filteredLead?.length ? filteredLead?.map((element) => { return { label: element?.name?.toUpperCase(), value: element?.leadId } }) : [])])
            } else {
                setLeadList([])
            }
        } else {
            setLeadList([])
        }
    }
    const getBookingDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        setLoading(false)
        if (response?.success) {
            const data = response?.data
            if (!data?.customer?.custStatus) {
                toast.error("Customer is deactive")
            }
            const mobileStatus = data?.customer?.custType === "local" ? (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (data?.customer?.phone?.length ? data?.customer?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)
            if (!mobileStatus || (data?.customer?.type === "Online" && data?.customer?.status !== "Verified")) {
                navigate(`/customer/update/${data?.customer?.customerId}`);
            }
            let pendingPhotoArray = data?.booking?.pendingPhoto?.length ? normalizePendingPhotos(data?.booking?.pendingPhoto) : []
            dispatch(setBooking({
                ...response?.data?.booking,
                pendingPhoto: pendingPhotoArray?.length ? pendingPhotoArray?.map(element => { return { url: element, file: element } }) : [],
                car: data?.car, carId: data?.booking?.carId, customer: data?.customer, firstName: data?.customer?.firstName, lastName: data?.customer?.lastName, phone: data?.customer?.phone?.length ? data?.customer?.phone?.filter(e => e.priority === 1)?.length ? data?.customer?.phone?.filter(e => e.priority === 1)[0] : {} : {}
            }))
            setPrev({ delivery: response?.data?.booking?.deliveryDetails?.price, pickup: response?.data?.booking?.pickupDetails?.price, securityDeposit: response?.data?.booking?.securityDeposit })
            if (data?.booking?.deliveryDetails?.delivery && data?.booking?.pickupDetails?.pickup) {
                if (data?.booking?.totalDays) {
                    const totalDays = Math.floor(data?.booking?.totalDays)
                    const point = Math.round((data?.booking?.totalDays % 1) * 10)
                    dispatch(setBooking({ totalDays, point: point > 0 ? 0.5 : 0 }))
                } else {
                    let diff = ((new Date(data?.booking?.pickupDetails?.pickup).getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                    if (Math.ceil(diff / 12) / 2 == 0.5) {
                        dispatch(setBooking({ totalDays: 1, halfDayOffer: 0, point: 0 }))
                    } else {
                        dispatch(setBooking({ totalDays: Math.floor(Math.ceil(diff / 12) / 2) }));
                        if (Math.ceil(diff / 12) % 2 !== 0) {
                            let to = new Date(data?.booking?.pickupDetails?.pickup)
                            to?.setHours(new Date(data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                            let diff1 = ((to?.getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                            if (Math.ceil(diff1 / 12) % 2 !== 0) {
                                dispatch(setBooking({ point: 0.5 }))
                            } else {
                                dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                            }
                        } else {
                            dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                        }
                    }
                }
            }
            dispatch(setPhone2(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 2)[0] : {} : {}))
            dispatch(setPhone3(data?.customer?.phone?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)?.length ? response?.data?.customer?.phone?.filter(e => e.priority === 3)[0] : {} : {}))
            dispatch(setStep(Number(response?.data?.booking?.screen) > 5 ? 0 : Number(response?.data?.booking?.screen)))
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const updateSteps = async () => await Handler({ method: 'PATCH', url: `/booking/change/step/${bookingId}?step=${step}`, data: {} })
    const handleSubmit = async () => {
        setLoading(true);
        const response = await Handler({
            method: 'patch', url: `/booking/close/sixth/update/${bookingId}`,
            data: {
                refundHold: {
                    hold1: booking?.refundHold?.hold1 || 0,
                    remarks: booking?.refundHold?.remarks || ''
                },
                totalCostCollected: booking?.totalCostCollected,
                ...(booking?.refund?.amount || booking?.refund?.offer ? {
                    refund: {
                        ...(Number(booking?.refund?.amount) ? { amount: booking?.refund?.amount || 0, mode: booking?.refund?.mode || '', remarks: booking?.refund?.remarks || '' } : {}),
                        ...(Number(booking?.refund?.offer) ? { offer: booking?.refund?.offer || 0, offerRemarks: booking?.refund?.offerRemarks || '' } : {})
                    }
                } : {}),
                ...(booking?.excessBalance?.length ? { excessBalance: booking?.excessBalance?.filter(element => element?.amount) || [] } : {}),
                custRemarks: booking?.customer?.remarks,
                pickupBy: booking?.pickupBy
            }
        })
        if (response?.success) {
            setTimeout(() => {
                reloadWindowToPath(`/booking/1`)
            }, 1500);
            toast.success(response?.message)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }

    }
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails?.price, booking?.pickupDetails?.price, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance?.amount])
    useEffect(() => {
        dispatch(clearValue())
        if (id) {
            setBookingId(id)
            getBookingDetails()
        }
    }, [id])
    useEffect(() => {
        const kmCharges = ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point || 0) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0))
            < 0 ?
            ((Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) - ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0))) * (booking?.car?.segment === "SUV" ? 10 : 7)
            : 0
        const kmDriven = (((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point || 0) === 0.5 ? 150 : 0)) - (Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0))) < 0 ? ((Number(booking?.km?.end || 0) - Number(booking?.km?.start || 0)) - ((Number(booking?.package || 0) * Number(booking?.totalDays || 0)) + (Number(booking?.point) === 0.5 ? 150 : 0))) : 0
        dispatch(setExcess({ kmCharges, kmDriven }))
    }, [booking?.km?.end, booking?.totalDays, booking?.package, booking?.car])
    useEffect(() => {
        let fuelConsumed = (Number(booking?.fuel?.end || 0) - Number(booking?.fuel?.start || 0)) < 0 ? (Number(booking?.fuel?.start || 0) - Number(booking?.fuel?.end || 0)) : 0
        dispatch(setExcess({ fuelConsumed, ...(fuelConsumed === 0 ? { fuelCharges: 0 } : {}) }))
    }, [booking?.fuel])
    useEffect(() => {
        if (Number(booking?.balancePaid) <= 0) {
            dispatch(setBooking({ balance: [] }))
        }
    }, [booking?.balancePaid])
    useEffect(() => {
        if (((Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0) + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0)) + (((Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) >= 0) ? (Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) : 0)) > Number(booking?.securityDeposit || 0))) {
            dispatch(setExcess({ amount: ((Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0) + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0)) + (((Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) >= 0) ? (Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) : 0)) - Number(booking?.securityDeposit || 0)) }))
        } else {
            dispatch(setExcess({ amount: 0 }))
        }
    }, [booking?.excessCharges, booking?.excess?.fuelCharges, booking?.excess?.kmCharges, booking?.excess?.timeCharges, booking?.securityDeposit])
    useEffect(() => {
        if (step === 5) {
            let excess = ((Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) >= 0) ? (Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) : 0
            let refund = (
                ((Number(booking?.securityDeposit || 0)) -
                    (
                        Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                        + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0))
                        + excess
                    )) > 0 ? ((Number(booking?.securityDeposit || 0)) -
                        (
                            Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)
                            + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0))
                            + excess
                        )) : 0
            )
            dispatch(setRefund({ amount: Number(refund || 0) + Number(booking?.refund?.offer || 0) }))
        }
    }, [booking?.refund?.offer, step])
    useEffect(() => {
        dispatch(setBooking({ totalCostCollected: (Number(booking?.totalAmount || 0) - Number(booking?.securityDeposit || 0) + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0) + Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)) + (((Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) >= 0) ? (Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) : 0)) }))
    }, [booking?.securityDeposit, booking?.excess, booking?.totalAmount, booking?.excessCharges, booking?.fastTag])
    const dl = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "dl") || {},
        [booking?.customer?.kyc]
    );

    const aadhaar = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "aadhaar") || {},
        [booking?.customer?.kyc]
    );

    const passport = useMemo(
        () => booking?.customer?.kyc?.find(el => el?.type === "passport") || {},
        [booking?.customer?.kyc]
    );
    useEffect(() => {
        if (userDetails?.id || userDetails?.adminId) {
            getLeadList();
        }
    }, [userDetails, booking?.stageHistory]);
    const initialLoad = useRef(true);
    useEffect(() => {
        if (!bookingId) return;

        if (initialLoad.current) {
            initialLoad.current = false;
            return;
        }

        updateSteps();
    }, [step]);
    return (
        <React.Fragment>
            <div className="arrow-back"><i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i></div>
            <h5 className="text-center text-theme fs-4">Booking Update</h5>
            <h6 className="text-center">Post Booking - Close</h6>
            <div className="layout-card mt-4">
                <div className="inside-fixed">
                    <div className="text-center fs-5 mb-3 fw-bold">Status: {booking?.status}</div>
                    <div className="row">
                        <div className="text-center col-sm-4"><span className="topTitle">Booking ID : </span>{(booking?.bookingId ? booking?.bookingId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Cust ID : </span>{(booking?.customerId ? booking?.customerId : "-")}</div>
                        <div className="text-center col-sm-4"><span className="topTitle">Booked Date : </span>{(booking?.createdAt ? moment(booking?.createdAt)?.format("DD/MM/YYYY") : "-")}</div>
                    </div>
                    <hr className="mb-5" />
                </div>
                <div className="row">
                    <div className="col-lg-3 d-lg-block d-flex justify-content-between mb-lg-0 mb-4 tab-col">
                        <div className="d-flex align-items-center gap-2">
                            <span className={`${step === 0 ? "active-tab" : (step > 0 ? "completed-tab" : "")} round-span`}>{step > 0 ? <i className="fa-solid fa-check"></i> : "1"}</span>
                            <div className={`register-tabs d-lg-block d-none`}>Customer Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 1 ? "active-tab" : (step > 1 ? "completed-tab" : "")} round-span`}>{step > 1 ? <i className="fa-solid fa-check"></i> : "2"}</span>
                            <div className="register-tabs d-lg-block d-none">Trip Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 2 ? "active-tab" : (step > 2 ? "completed-tab" : "")} round-span`}>{step > 2 ? <i className="fa-solid fa-check"></i> : "3"}</span>
                            <div className="register-tabs d-lg-block d-none">Payment Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 3 ? "active-tab" : (step > 3 ? "completed-tab" : "")} round-span`}>{step > 3 ? <i className="fa-solid fa-check"></i> : "4"}</span>
                            <div className="register-tabs d-lg-block d-none">Other Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 4 ? "active-tab" : (step > 4 ? "completed-tab" : "")} round-span`}>{step > 4 ? <i className="fa-solid fa-check"></i> : "5"}</span>
                            <div className="register-tabs d-lg-block d-none">Booking Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 5 ? "active-tab" : (step > 5 ? "completed-tab" : "")} round-span`}>{step > 5 ? <i className="fa-solid fa-check"></i> : "6"}</span>
                            <div className="register-tabs d-lg-block d-none">Price Info</div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {
                            step === 0 ?
                                <CustomerEdit bookingId={bookingId} />
                                : step === 1 ?
                                    <Trip leadList={leadList} bookingId={bookingId} />
                                    : step === 2 ?
                                        <Payment bookingId={bookingId} prev={prev} />
                                        : step === 3 ?
                                            <Other bookingId={bookingId} />
                                            : step === 4 ?
                                                <Pending leadList={leadList} bookingId={bookingId} />
                                                : step === 5 ?
                                                    <Price bookingId={bookingId} setPreview={setPreview} />
                                                    : ""
                        }
                    </div>
                </div>
            </div>
            <Modal fullScreen={"true"} header="Preview" size={'lg'} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="row justify-content-center mb-3 align-items-stretch">
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer ID </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={booking?.customerId} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer Name </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Mobile </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone?.code || "") + "-" + (booking?.phone?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 1 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone2?.code || "") + "-" + (booking?.phone2?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Alt Number 2 </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone3?.code || "") + "-" + (booking?.phone3?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-3">
                        <div className="col-lg-4">
                            <div className="form_title mb-4 text-center fw-bold"> Trip Info</div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.pickup ? moment(new Date(booking?.pickupDetails?.pickup))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Pickup Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Package: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.package} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Start KM: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.km?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > End KM: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.km?.end || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fuel: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fuel?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  End Fuel: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fuel?.end || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Start Fastag: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fastTag?.start || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  End Fastag: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.fastTag?.end || 0} readOnly />
                                </div>
                            </div>
                            <div className="form_title mb-4 text-center fw-bold"> Refund Info </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Total Cost Collected: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={(Number(booking?.totalAmount || 0)) - Number(booking?.securityDeposit || 0) + (Number(booking?.excess?.fuelCharges || 0) + Number(booking?.excess?.kmCharges || 0) + Number(booking?.excess?.timeCharges || 0) + Number(booking?.excessCharges?.length ? booking?.excessCharges?.reduce((total, num) => total + Number(num?.amount || 0), 0) : 0)) + (((Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) >= 0) ? (Number(booking?.fastTag?.start || 0) - Number(booking?.fastTag?.end || 0)) : 0)} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Refund Amount: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.refund?.amount || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Refund Amount Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.refund?.mode || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Refund Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.refund?.remarks || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Refund Offer Amount: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.refund?.offer || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label">  Refund Offer Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase text-capitalize" autoComplete="off" id="modalInput" value={booking?.refund?.remarks || ""} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Payment Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Days: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.totalDays + booking?.point} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Cost per day: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={(Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.point === 0.5 ?
                                    <div className="row mb-3">
                                        <label className="col-sm-5 col-form-label" > Half day rent: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={((Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0)) || 0} readOnly />
                                        </div>
                                    </div> : ""
                            }
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Cost: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={
                                        (booking?.totalDays * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0) || 0
                                    } readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Security Deposit: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.securityDeposit || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.paid || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.mode || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3 d-flex align-items-center">
                                <label className="col-sm-5 col-form-label" > Advance Paid Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.remarks || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Balance to be Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.balancePaid || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.balance?.length ?
                                    booking?.balance?.map((element, i) => {
                                        return (
                                            <div key={i}>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Amount {i + 1}: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.amount || 0} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Mode: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.mode || ""} readOnly />
                                                    </div>
                                                </div>
                                                <div className="row mb-3 d-flex align-items-center">
                                                    <label className="col-sm-5 col-form-label" > Balance Paid Remarks: </label>
                                                    <div className="col-sm-7">
                                                        <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={element?.remarks || ""} readOnly />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                    : ""
                            }
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-4 text-center fw-bold"> Excess Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess KM Driven: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.kmDriven || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess KM Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.kmCharges || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Fuel Consumed: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.fuelConsumed || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Fuel Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.fuelCharges || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Hour Used: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.timeUsed || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Excess Hour Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excess?.timeCharges || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Fine Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.amount : "") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Fine Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "fine")?.length ? booking?.excessCharges?.filter(element => element?.name === "fine")[0]?.remarks : "") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Damage Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.amount : "") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Damage Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "damage")?.length ? booking?.excessCharges?.filter(element => element?.name === "damage")[0]?.remarks : "") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Other Charges: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "other")?.length ? booking?.excessCharges?.filter(element => element?.name === "other")[0]?.amount : "") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Other Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.excessCharges?.length ? (booking?.excessCharges?.filter(element => element?.name === "other")?.length ? booking?.excessCharges?.filter(element => element?.name === "other")[0]?.remarks : "") : ""} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-100 text-center">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL  </div> </div>
                                    <div className="col"><div className={dl?.id ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> DL Photo </div> </div>
                                    <div className="col"><div className={dl?.photo?.length ? "card-text" : "red card-text"}>  {dl?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : dl?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar  </div> </div>
                                    <div className="col"><div className={aadhaar?.id ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Aadhaar Photo </div> </div>
                                    <div className="col"><div className={aadhaar?.photo?.length ? "card-text" : "red card-text"}>  {aadhaar?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : aadhaar?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport </div> </div>
                                    <div className="col"><div className={passport?.id ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.id ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="row">
                                    <div className="col"> <div className="card-title headingCard"> Passport Photo </div> </div>
                                    <div className="col"><div className={passport?.photo?.length ? "card-text" : "red card-text"}>  {passport?.status ? <>Verified <i className="fa-regular fa-circle-check success"></i></> : passport?.photo?.length ? <>Uploaded <i className="fa-regular fa-circle-check success"></i></> : <>Pending <i className="pending fa-solid fa-hourglass-half"></i></>} </div> </div>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-success" disabled={loading} onClick={handleSubmit}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button>
                    </div>
                </div>
                {/* <div className="overflow">
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="text-center">
                                <th> Proof </th>
                                <th> Status </th>
                                <th> Photo </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="align-middle text-center">
                                <td> Mobile </td>
                                <td> {(booking?.customer?.custType === "local" ? (booking?.customer?.phone?.length ? booking?.customer?.phone?.filter((phone) => phone?.status)?.length >= 3 : false) : (booking?.customer?.phone?.length ? booking?.customer?.phone?.filter((phone) => phone?.status)?.length >= 2 : false)) ? "Verified" : "Unverified"} </td>
                                <td> - </td>
                            </tr>
                            <tr className="align-middle text-center">
                                <td> DL </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.status) : false : false) ? "Verified" : "Unverified"} </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "dl")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "dl")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                            </tr>
                            <tr className="align-middle text-center">
                                <td> Aadhar </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "aadhaar")[0]?.status) : false : false) ? "Verified" : "Unverified"} </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "aadhaar")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "aadhaar")[0]?.photo?.length >= 2) : false : false) ? "Uploaded" : "Pending"} </td>
                            </tr>
                            <tr className="align-middle text-center">
                                <td> Passport </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "passport")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "passport")[0]?.status) : false : false) ? "Verified" : "Unverified"} </td>
                                <td> {(booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter(element => element?.type === "passport")?.length ? (booking?.customer?.kyc?.filter(element => element?.type === "passport")[0]?.photo?.length >= 3) : false : false) ? "Uploaded" : "Pending"} </td>
                            </tr>
                        </tbody>
                    </table>
                    
                </div> */}
            </Modal>
        </React.Fragment>
    )
}

export default Delivery;